// cascade-signal.js — the auto-advance decision, alone, with no dependencies.
//
// Deliberately NOT inside CascadeSelect.jsx (Alex, 2026-08-04: "Cascade confidence =
// I am not confident!"). This one decision has shipped a bug three times and the build
// was green every time; it is the thing that most needs a test, and a test cannot
// import a .jsx file under plain node. So it lives here, in a file with no React and
// no JSX, and test/cascade.test.mjs pins it.
//
// THE CONVENTION (produced by useCascadeSignal in CascadeSelect.jsx): a level's signal
// is `undefined` unless that level is the one being advanced to RIGHT NOW, in which
// case it is a monotonically increasing number.
//
//   incoming == null          -> not the target. Never open.
//   incoming === lastHandled  -> this exact bump was already acted on. Never re-open:
//                                a re-render, an Escape, or a click-away must not
//                                resurrect it (that was bug #1).
//   otherwise                 -> the target, now. Open.
//
// A control that MOUNTS holding a defined signal therefore opens. That is not an edge
// case, it is the common one: the catalog item picker only exists once search results
// arrive, i.e. after the pick that targeted it (that was bug #3).
export function shouldOpenFromSignal(lastHandled, incoming) {
  if (incoming == null) return false;
  if (lastHandled === incoming) return false;
  return true;
}
